import {CALL_API} from '../../middleware/api';

export const POSITION_GET_ALL_REQUEST = 'POSITION_GET_ALL_REQUEST';
export const POSITION_GET_ALL_SUCCESS = 'POSITION_GET_ALL_SUCCESS';
export const POSITION_GET_ALL_FAILURE = 'POSITION_GET_ALL_FAILURE';

export function getAllPositions() {
	return {
		[CALL_API]: {
			types: [POSITION_GET_ALL_REQUEST, POSITION_GET_ALL_SUCCESS, POSITION_GET_ALL_FAILURE],
			endpoint: 'organization/position/getall',
		}
	};
}

export default () => {
	return (dispatch) => {
		return dispatch(getAllPositions());
	};
};


// WEBPACK FOOTER //
// ./src/action/position/getall.js